<template>
  <div class="lab-document-page">
    <div class="page-header">
      <a @click="goBack" class="lab-name">
        <i class="el-icon-back"></i>
        <span>返回</span>
        {{ expName }}
      </a>
    </div>
    <div class="page-main-content" v-show="expContentType == 1">
      <div class="doc-content-nav" id="nav"></div>
      <div class="doc-content-right">
        <div class="markdown-body" id="mdBody" @click="imageChange($event)"></div>
      </div>
    </div>
    <div class="imgDolg" v-show="imgPreview.show" @click.stop="imgPreview.show = false">
      <i class="el-icon-close" id="imgDolgClose" @click.stop="imgPreview.show = false"></i>
      <img @click.stop="imgPreview.show = true" :src="imgPreview.img" />
      <i class="el-icon-caret-left" id="imgDolgLeft" @click.stop="jumpImage('previous')"></i>
      <i class="el-icon-caret-right" id="imgDolgRight" @click.stop="jumpImage('next')"></i>
    </div>
    <div class="lab-editor" v-if="expContentType == 2">
      <div class="lab-editor-son" style="clear: both" @click="imageChange($event)" v-html="expRecordInfo.content"></div>
    </div>
    <div class="lab-pdf" v-else-if="expContentType == 3">
      <embed type="application/pdf" :src="pdfUrl | filterUrl" />
    </div>
  </div>
</template>

<script>
import { getExpDetailByUid } from "@/api/exp/experiment";
import "@/assets/css/github-markdown.min.less";
import "@/assets/css/katex.min.less";
import { getFileInfoByUid } from "@/api/file";

export default {
  data() {
    return {
      expName: "",
      imageData: [], //提取所有图片的路径
      navList: [],
      topList: {},
      sortTop: [],
      target: "",
      pdfUrl: "",
      expContentType: null,
      expRecordInfo: {},
      imgPreview: {
        img: "",
        show: false,
      },
    };
  },
  created() {
    const uid = this.$route.params.fileUid;
    this.init(uid);
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("mdBody").addEventListener("scroll", this.handleScroll);
      setTimeout(() => {
        const h1 = document.getElementsByTagName("h1");
        const h2 = document.getElementsByTagName("h2");
        const h3 = document.getElementsByTagName("h3");
        const h = [...h1, ...h2, ...h3];
        let tops = [];
        let topList = {};
        for (let i = 0; i < h.length; i++) {
          let row = h[i];
          const childA = row.firstChild;
          if (childA != "目录" && childA.id) {
            topList[row.offsetTop - 65] = childA.id;
            tops.push(row.offsetTop - 65);
          }
        }
        this.sortTop = this.sortH(tops);
        this.sortTop.map((row) => {
          this.topList[row] = topList[row];
        });
      }, 500);
      // 添加点击事件
      document.getElementById("nav").addEventListener("click", (e) => {
        e = e || window.event;
        const target = e.target || e.srcElement;
        const href = target.getAttribute("href");
        if (href) {
          // 清除其他样式
          const activeA = document.getElementsByClassName("active");
          if (activeA.length > 0)
            for (let i = 0; i < activeA.length; i++) {
              activeA[i].className = "";
            }
          target.className = "active";
        }
      });
    });
  },
  methods: {
    jumpImage(val) {
      let len = this.imageData.indexOf(this.imgPreview.img);
      if (val == "next") {
        len++;
        if (len < this.imageData.length) {
          this.imgPreview.img = this.imageData[len];
        }
      } else if (val == "previous") {
        len--;
        if (len >= 0) {
          this.imgPreview.img = this.imageData[len];
        }
      }
    },
    imageChange(e) {
      if (e.target.tagName == "IMG") {
        console.log(e)
        this.imgPreview.img = e.target.src;
        this.imgPreview.show = true;
      }
    },
    goBack() {
      //返回上一级页面
      const { uid } = this.$route.params;
      let key = uid;
      if (uid.length < 32) {
        this.$router.push(`/edu/${key}/detail`);
      } else {
        this.$router.push({ path: `/lesson/${uid}/type/exp` });
      }
    },
    init(uid) {
      getExpDetailByUid(uid).then((res) => {
        this.expName = res.name;
        this.expRecordInfo = res;
        const mdHtml = res.content.split("<p></p>");
        this.expContentType = res.expContentType;
        if (mdHtml.length > 2) {
          document.getElementById("nav").innerHTML = mdHtml[1];
          // 提取软件
          const outHtml = mdHtml[2].split(/<soft>|<\/soft>/);
          let realHtml = "";
          outHtml.map((row) => {
            if (row != "" && row.indexOf("data-code") == -1) {
              realHtml += row;
            }
          });
          document.getElementById("mdBody").innerHTML = realHtml;
          realHtml.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
            this.imageData.push(capture);
          });
        } else {
          document.getElementById("mdBody").innerHTML = res.content;
          res.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
            this.imageData.push(capture);
          });
        }
        if (res.expContentType == 3) {
          getFileInfoByUid(res.content).then((res) => {
            this.pdfUrl = res.originalPath;
          });
        }
      });
    },
    handleScroll() {
      const dom = document.getElementById("mdBody");
      let scrollTop = window.pageYOffset || dom.scrollTop;
      // 判断页面滚动到哪个元素上
      let nowTop;
      for (let i = 0; i < this.sortTop.length - 1; i++) {
        if (scrollTop > this.sortTop[i] && scrollTop < this.sortTop[i + 1]) {
          nowTop = this.sortTop[i];
        }
      }
      if (nowTop && this.target != this.topList[nowTop]) {
        this.target = this.topList[nowTop];
        // 清除其他样式
        const activeA = document.getElementsByClassName("active");
        if (activeA.length > 0)
          for (let i = 0; i < activeA.length; i++) {
            activeA[i].className = "";
          }
        const as = document.getElementsByTagName("a");
        for (let j = 0; j < as.length; j++) {
          const row = as[j];
          if (row.getAttribute("href") == `#${this.target}`) row.className = "active";
        }
      }
    },
    // 对数据进行排序
    sortH(array) {
      var len = array.length,
        i,
        j,
        tmp,
        result;
      result = array.slice(0);
      for (i = 0; i < len; i++) {
        for (j = len - 1; j > i; j--) {
          if (result[j] < result[j - 1]) {
            tmp = result[j - 1];
            result[j - 1] = result[j];
            result[j] = tmp;
          }
        }
      }
      return result;
    },
  },
};
</script>
<style lang="less" scoped>
.lab-pdf {
  width: 100%;
  height: 100%;
  embed {
    width: 100%;
    height: 100%;
  }
}
.lab-editor {
  height: 100%;
  overflow: auto;
}
.imgDolg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  background-color: rgba(140, 134, 134, 0.5);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  #imgDolgClose {
    position: fixed;
    top: 20px;
    cursor: pointer;
    right: 40px;
    font-size: 50px;
    color: white;
  }
  #imgDolgLeft {
    position: fixed;
    top: 50%;
    cursor: pointer;
    left: 40px;
    font-size: 50px;
    color: white;
  }
  #imgDolgRight {
    position: fixed;
    top: 50%;
    cursor: pointer;
    right: 20px;
    font-size: 50px;
    color: white;
  }
  img {
    width: 80%;
    height: 80%;
  }
}
</style>
